var map = {
	"./icons/arrow_left.svg": 3556,
	"./icons/arrow_right.svg": 219,
	"./icons/arrow_right_lucide.svg": 4218,
	"./icons/arrows_up_down.svg": 9272,
	"./icons/calendar.svg": 3060,
	"./icons/caret_down.svg": 9221,
	"./icons/caret_left.svg": 5166,
	"./icons/caret_right.svg": 5677,
	"./icons/check.svg": 1691,
	"./icons/chevron_down.svg": 7009,
	"./icons/display_logo.svg": 2269,
	"./icons/edit_dots.svg": 7304,
	"./icons/error.svg": 8029,
	"./icons/eye.svg": 4704,
	"./icons/eye_off.svg": 686,
	"./icons/filetype_folder.svg": 3766,
	"./icons/filetype_generated.svg": 2097,
	"./icons/filetype_group.svg": 7583,
	"./icons/filetype_set.svg": 6606,
	"./icons/filetype_single_image.svg": 2004,
	"./icons/filetype_single_pdf.svg": 8005,
	"./icons/filetype_single_video.svg": 4126,
	"./icons/home.svg": 532,
	"./icons/hourglass.svg": 9029,
	"./icons/info.svg": 7865,
	"./icons/list.svg": 3909,
	"./icons/log_out.svg": 8404,
	"./icons/logout.svg": 8619,
	"./icons/menu.svg": 7184,
	"./icons/nav_dashboard.svg": 5473,
	"./icons/nav_displays.svg": 4358,
	"./icons/nav_generator.svg": 1446,
	"./icons/nav_media.svg": 9897,
	"./icons/nav_playlists.svg": 7760,
	"./icons/nav_redaktion.svg": 3898,
	"./icons/nav_settings.svg": 736,
	"./icons/nav_users.svg": 6425,
	"./icons/sorting.svg": 1803,
	"./icons/success.svg": 2110,
	"./icons/tiles.svg": 5592,
	"./icons/times.svg": 5477,
	"./icons/trash.svg": 297,
	"./icons/trash_outline.svg": 4438,
	"./icons/upload.svg": 2030,
	"./icons/warning.svg": 9251,
	"./icons/x.svg": 1967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7665;